import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorldNetwork = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "World Network",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 21.75C6.62 21.75 2.25 17.38 2.25 12C2.25 6.62 6.62 2.25 12 2.25C17.38 2.25 21.75 6.62 21.75 12C21.75 17.38 17.38 21.75 12 21.75ZM12 3.75C7.45 3.75 3.75 7.45 3.75 12C3.75 16.55 7.45 20.25 12 20.25C16.55 20.25 20.25 16.55 20.25 12C20.25 7.45 16.55 3.75 12 3.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9999 21.75C9.3099 21.75 7.8999 16.84 7.8999 12C7.8999 7.16 9.3099 2.25 11.9999 2.25C14.6899 2.25 16.0999 7.15 16.0999 12C16.0999 16.85 14.6899 21.75 11.9999 21.75ZM11.9999 3.75C10.9399 3.75 9.3999 6.96 9.3999 12C9.3999 17.04 10.9399 20.25 11.9999 20.25C13.0599 20.25 14.5999 17.04 14.5999 12C14.5999 6.96 13.0599 3.75 11.9999 3.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 9.71998C10.93 9.71998 9.86004 9.65998 8.80004 9.54998C7.01004 9.35998 5.32004 9.02998 3.80004 8.55998C3.40004 8.43998 3.18004 8.01998 3.30004 7.61998C3.42004 7.22998 3.84004 6.99998 4.24004 7.11998C5.67004 7.55998 7.26004 7.87998 8.96004 8.05998C10.98 8.26998 13.03 8.26998 15.06 8.05998C16.76 7.87998 18.34 7.56998 19.78 7.11998C20.18 6.99998 20.6 7.21998 20.72 7.61998C20.84 8.01998 20.62 8.43998 20.22 8.55998C18.69 9.02998 17.01 9.36998 15.22 9.54998C14.15 9.65998 13.08 9.71998 12.01 9.71998H12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.01003 16.91C3.69003 16.91 3.39003 16.7 3.29003 16.38C3.17003 15.98 3.39003 15.56 3.79003 15.44C5.32003 14.97 7.00003 14.64 8.79003 14.45C10.91 14.23 13.07 14.23 15.2 14.45C16.99 14.64 18.67 14.97 20.2 15.44C20.6 15.56 20.82 15.98 20.7 16.38C20.58 16.78 20.16 17 19.76 16.88C18.32 16.44 16.74 16.12 15.04 15.95C13.01 15.74 10.96 15.74 8.94003 15.95C7.25003 16.13 5.66003 16.44 4.22003 16.88C4.15003 16.9 4.07003 16.91 4.00003 16.91H4.01003Z",
			fill: "currentColor"
		})
	]
});
export default SvgWorldNetwork;
